import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "../../context/Use-Context";
import { AuthContext } from "../../context/App-Context";

const TgProfile = () => {
  const auth = useContext(AuthContext);

  // Profile Pic State
  const [profilePic, setProfilePic] = useState(null);
  const [bio, setBio] = useState("");
  const [title, setTitle] = useState("");
  const [data, setData] = useState(null);

  // Change Password State
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  // Email Verification State
  const [isEmailCodeSent, setIsEmailCodeSent] = useState(false);
  const [emailCode, setEmailCode] = useState("");

  // console.log(AuthContext.loginVar);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getUserByParameters/${auth.loginVar}`
        );
        // console.log(auth.loginVar);
        setData(response.data.data);
        // console.log(response.data.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [auth.loginVar]);

  // --- PROFILE PICTURE HANDLERS ---
  const handleFileChange = (e) => {
    setProfilePic(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!profilePic) {
      alert("Please select a profile picture");
      return;
    }

    const formData = new FormData();
    formData.append("email", data[0].email);
    formData.append("username", auth.loginVar);
    formData.append("profilePic", profilePic);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/updateProfilePic`,
        formData
      );
      alert("Profile saved successfully!");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Error saving profile. Please try again.");
    }
  };

  // --- PASSWORD HANDLER ---
  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      // NOTE: Update this URL to match your exact Express route for changing passwords
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/changeTgridUserPassword`,
        {
          username: auth.loginVar,
          password: currentPassword,
          newPassword: newPassword,
        },
        { withCredentials: true } // Important for sending/receiving cookies if needed
      );

      alert(response.data.message || "Password updated successfully!");
      setCurrentPassword("");
      setNewPassword("");
    } catch (error) {
      console.error("Password change failed:", error);
      alert(error.response?.data?.error || "Error changing password.");
    }
  };

  // --- EMAIL VERIFICATION HANDLERS ---
  const handleSendEmailCode = async () => {
    try {
      // NOTE: Update this URL to match your exact Express route for email verification
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/verifyTempleGridUserEmail`,
        {
          username: auth.loginVar,
          action: "send",
        },
        { withCredentials: true } // CRITICAL for receiving the JWT cookie
      );
      setIsEmailCodeSent(true);
      alert("Verification code sent to your email.");
    } catch (error) {
      console.error("Failed to send email code:", error);
      alert("Error sending code. Please try again.");
    }
  };

  const handleVerifyEmailCode = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/verifyTempleGridUserEmail`,
        {
          username: auth.loginVar,
          action: "verify",
          code: emailCode,
        },
        { withCredentials: true } // CRITICAL for sending the JWT cookie back
      );

      alert(response.data.message || "Email verified successfully!");
      setIsEmailCodeSent(false);
      setEmailCode("");
      // Optionally trigger fetchData() again here to update the user's verified status in UI
    } catch (error) {
      console.error("Verification failed:", error);
      alert(error.response?.data?.error || "Invalid code. Please try again.");
    }
  };

  //// check verified email

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getUserByParameters/${auth.loginVar}`
  //       );
  //       setData(response.data.data);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };
  //   fetchData();
  // }, [auth.loginVar]);

  //// check 2-step-authentication

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getUserByParameters/${auth.loginVar}`
  //       );
  //       setData(response.data.data);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };
  //   fetchData();
  // }, [auth.loginVar]);

  return (
    <div className="templegrid">
      <div className="templegrid-courtyard-setting"></div>
      <div className="profile-form-container">
        {/* PROFILE PICTURE FORM */}
        <form onSubmit={handleSubmit}>
          <label htmlFor="profilePic">Profile Picture</label>
          <input
            type="file"
            id="profilePic"
            onChange={handleFileChange}
            className="input-file"
          />
          {profilePic && (
            <div style={{ marginTop: "10px" }}>
              <img
                src={URL.createObjectURL(profilePic)}
                alt="Preview"
                style={{ maxWidth: "200px", maxHeight: "200px" }}
              />
            </div>
          )}
          <button type="submit" className="purple-button">
            Save Profile
          </button>
        </form>

        {/* <hr />

     
        <div>
          <h3>Email Verification</h3>

          {data && data[0].email && <div>Email: {data[0].email}</div>}

          {data && data[0].accountVerified ? (
            <div
              style={{ color: "blue", fontWeight: "bold", margin: "10px 0" }}
            >
              ✓ Email Verified
            </div>
          ) : !isEmailCodeSent ? (
            <button onClick={handleSendEmailCode} className="purple-button">
              Send Verification Code
            </button>
          ) : (
            <form onSubmit={handleVerifyEmailCode}>
              <div className="form-group">
                <label htmlFor="emailCode">Enter 6-Digit Code</label>
                <input
                  type="text"
                  id="emailCode"
                  value={emailCode}
                  onChange={(e) => setEmailCode(e.target.value)}
                  placeholder="123456"
                  className="input-field"
                  maxLength="6"
                  required
                />
              </div>
              <button type="submit" className="purple-button">
                Verify Code
              </button>
            </form>
          )}

          {data && data[0].accountVerified && (
            <div>
              <button className="purple-button">
                Toggle 2-Step Authentication
              </button>
            </div>
          )}
        </div>

        <hr />

        <div>
          <h3>Phone Verification</h3>
          <div>verify phone number</div>
        </div>

        <hr /> */}

        {/* CHANGE PASSWORD FORM */}
        <div>
          <h3>Change Password</h3>
          <form onSubmit={handleChangePassword}>
            <div className="form-group">
              <label htmlFor="currentPassword">Current Password</label>
              <input
                type="password"
                id="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Enter current password"
                className="input-field"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                className="input-field"
                required
              />
            </div>
            <button type="submit" className="purple-button">
              Update Password
            </button>
          </form>
        </div>

        <hr />

        <button onClick={auth.logout} className="purple-button">
          logout
        </button>
      </div>
    </div>
  );
};

export default TgProfile;
